import React, { createContext, useContext } from 'react';
import { ApiEmployerRepository } from '@/features/section-1/features/employer-selection/infra/repositories/ApiEmployerRepository';
import { EmployeeInfoUseCase } from '../../application/useCase/employeeInfoUseCase';
import { useHttpClientCore } from '@/shared';

interface IEmployeeInfoDIContext {
  employeeInfoUseCase: EmployeeInfoUseCase;
}

export const EmployeeInfoDIContext = createContext<IEmployeeInfoDIContext | undefined>(undefined);

export const EmployeeInfoDIProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const httpClient = useHttpClientCore();
  const employerRepository = new ApiEmployerRepository(httpClient);
  const employeeInfoUseCase = new EmployeeInfoUseCase(employerRepository);

  return (
    <EmployeeInfoDIContext.Provider value={{ employeeInfoUseCase }}>
      {children}
    </EmployeeInfoDIContext.Provider>
  );
};

export function useEmployeeInfoDIContext() {
  const ctx = useContext(EmployeeInfoDIContext);
  if (!ctx) throw new Error('useEmployeeInfoDIContext must be used within EmployeeInfoDIProvider');
  return ctx;
}
